import { AxiosInstance } from 'axios';

export interface IntentsAuthProvider {
    bootstrap(axios: AxiosInstance): Promise<AxiosInstance>;
    updateToken(axios: AxiosInstance, token: string): void;
    addBearer(axios: AxiosInstance, token: string): void;
    setInterceptors(axios: AxiosInstance): void;
}

export const authProviderDefaults: IntentsAuthProvider = {
    bootstrap: async function (axios: AxiosInstance): Promise<AxiosInstance> {
        return axios;
    },
    updateToken: function (axios: AxiosInstance, token: string): void {
        axios.defaults.headers['40seas-token'] = token;
    },
    addBearer: function (axios: AxiosInstance, token: string): void {
        axios.defaults.headers['Authorization'] = `Bearer ${token}`;
    },
    setInterceptors: function (axios: AxiosInstance): void {
        axios.interceptors.response.use(
            (response) => {
                const headerValue = response.headers['40seas-token'];

                if (headerValue) {
                    this.updateToken(axios, headerValue);
                }

                return response;
            },
            (error) => {
                return Promise.reject(error);
            },
        );
    },
};
